export const blockIconsAndroidQuickPhrasesNew = (
	<span className='material-symbols-outlined'>quick_phrases</span>
);
